// extracted by mini-css-extract-plugin
export default {"order":"order__order--_yQvQ"};